/**
 * The corresponding verification method type
 * @enum {string}
 */
export const VerificationMethods = Object.freeze({
    Text: "Text",
    Email: "Email"
});